document.addEventListener("DOMContentLoaded", () => {
  const effectScroll2 = document.querySelector(".history__progress");

  if (effectScroll2) {
    const getPercentageOffScreenTop = () => {
      const element = document.querySelector(".history__content");
      if (!element) return;

      const elementRect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const elementHeight = elementRect.height;

      if (elementRect.bottom < 0) return 100;
      if (elementRect.top >= windowHeight) return 0;

      const offScreenAmount = Math.max(0, -elementRect.top);
      let percentageOffScreen = (offScreenAmount / elementHeight) * 100;
      return Math.min(percentageOffScreen, 100);
    };

    const onScroll = () => {
      const multiplier = window.innerWidth === 797 ? 1.5 : 1.2;
      const percentage = getPercentageOffScreenTop() * multiplier;

      effectScroll2.style.background = `linear-gradient(180deg, rgba(0,0,0,1) ${percentage}%, rgba(224, 215, 213, 1) ${percentage}%)`;
    };

    window.addEventListener("scroll", onScroll);
    onScroll();
  }
});
